import React from "react";
import styled from "styled-components";
import { colors } from "../../../../utils";
import TextView from "../../../TextView";
import { ASSETS } from "../../../../utils/config";
import { Box, Stack } from "@mui/material";
import { toast } from "react-toastify";

const Container = styled.div`
  width: 100%;
  background-color: ${colors.background};
  border-radius: 8px;
  padding: 16px;
  border: 1px solid ${colors.lightBorder};
`;

const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const ImageWrapper = styled.div`
  width: 64px;
  height: 64px;
  position: relative;
  margin-right: 16px;
`;

const Image = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 4px;
  object-fit: cover;
  border: 1px solid ${colors.lightGrey};
`;

const Icon = styled.img`
  cursor: pointer;
  margin-left: 10px;
  width: ${({ size }) => (size ? size : "20px")};
  height: ${({ size }) => (size ? size : "20px")};
`;

const URLContainer = styled.div`
  margin-top: 16px;
  padding: 6px;
  background-color: white;
  border-radius: 8px;
  border: 1px solid ${colors.lightBorder};
`;

const URLRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
`;

const URLInput = styled.input`
  flex: 1;
  padding: 0px;
  border-radius: 4px;
  font-size: 14px;
  background-color: #fff;
  color: ${colors.darkGrey};
  border: none;
  outline: none;

  &:focus {
    border-color: none;
  }
`;

const CopyButton = styled.button`
  padding: 8px 16px;
  background-color: #9b5af8;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background-color: ${colors.darkPurple};
  }

  &:active {
    transform: translateY(1px);
  }
`;

export default function UploadedImage({
  image,
  title,
  handleRemoveImage,
  setOpen,
  showURL = true,
}) {
  const handleCopyURL = async () => {
    try {
      await navigator.clipboard.writeText(image);
      toast.success("URL copied to clipboard");
    } catch (err) {
      console.error("Failed to copy URL:", err);
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = image;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    }
  };
  return (
    <Container>
      <Stack
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
      >
        <TextView variant="subtitle">Uploaded</TextView>

        <Box>
          <Icon src={ASSETS.EditImage} onClick={() => setOpen(true)} />
          <Icon src={ASSETS.deleteIcon2} onClick={handleRemoveImage} />
        </Box>
      </Stack>
      <Row style={{ marginTop: 10 }}>
        <ImageWrapper>
          <Image src={image} />
        </ImageWrapper>
        <TextView variant="subtitle">
          {title ? title : "Untitled image"}
        </TextView>
      </Row>
      {showURL && (
        <URLContainer>
          <URLRow>
            <URLInput
              type="text"
              value={image}
              readOnly
              placeholder="Image URL"
            />
            <CopyButton onClick={handleCopyURL}>Copy URL</CopyButton>
          </URLRow>
        </URLContainer>
      )}
    </Container>
  );
}
